import { useQuery } from 'react-query';
import { apiService } from '../../../utils/api';

const useGetDocumentation = (id) => {
  return useQuery({
    queryKey: ['documentation', id],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await apiService.get(`/api/v1/documentation/${id}/`);
      return data;
    },
    refetchOnWindowFocus: false,
  });
};

export default useGetDocumentation;
